import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ImportMenuView from 'components/ImportMenu/ImportMenuView';
import {
  importMenuV2,
  emptyMenuHistoryV2,
  getCurrentMenuId,
  exportMenuV2,
} from 'redux/actions/Menu/menuV2';

const BREAK_GLASS_PAGE = 'menu-import';
const EMPTY_ACTION_SUMMARY = 'Empty menu for this business';

const MenuImport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentBusiness = useSelector(
    ({ business }) => business.currentBusiness
  );
  const businessUuid = currentBusiness?.uuid;

  const handleEmpty = async () => {
    let menuId;
    try {
      menuId = await dispatch(getCurrentMenuId());
    } catch (err) {
      toast.error(t('Failed to load the current menu. Empty was not started.'));
      throw err;
    }
    return dispatch(emptyMenuHistoryV2([menuId], businessUuid));
  };

  return (
    <ImportMenuView
      businessUuid={businessUuid}
      breakGlassPage={BREAK_GLASS_PAGE}
      breakGlassEventType="menu-import-action"
      emptyActionSummary={EMPTY_ACTION_SUMMARY}
      subtitle="Import a menu from a JSON file or start from an empty menu."
      comingSoonProviders={[]}
      onImport={(parsedMenu) => dispatch(importMenuV2(businessUuid, parsedMenu))}
      onEmpty={handleEmpty}
      onExport={() => dispatch(exportMenuV2())}
      exportFileType="menu"
      businessName={currentBusiness?.companyName}
    />
  );
};

export default MenuImport;
